// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 640px){.epa-header img[title="Official EPA Logo"]{margin-left:2em}}`, "",{"version":3,"sources":["webpack://./srcjs/index.scss"],"names":[],"mappings":"AAAA,qCAAA,2CAAA,eAAA,CAAA","sourcesContent":["@media screen and (min-width: 640px){.epa-header img[title=\"Official EPA Logo\"]{margin-left:2em}}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
